import { Button, Col, ProgressBar, Row } from "react-bootstrap";
import {
  IFullLicenceDetails,
  OpenForSubmissionOptions,
} from "../../../../api/LicenceDetails";
import { ILicenceProfile } from "../../../../api/LicenceProfile";
import {
  GetMakeAnObjectionUrl,
  GetSubmissionUrl,
} from "../../../../external-apps/Config";
import EpaCard from "../../../../leap-components/EpaCard";
import EpaField from "../../../../leap-components/EpaField";

const pendingProgressBackgroundColor = "#ddd";

interface ILicenceDetailsProps {
  licence: IFullLicenceDetails;
  licenceProfile: ILicenceProfile;
}

const LicenceApplicationTrackerDesktop = ({
  licence,
  licenceProfile,
}: ILicenceDetailsProps) => {
  var bodyElements = (
    <div>
      <ProgressBar style={{ height: "1rem", fontSize: "0.9rem" }}>
        <ProgressBar variant="primary" now={17} key={1} />
        <ProgressBar variant="primary" now={8} key={2} />
        <ProgressBar
          style={{ backgroundColor: pendingProgressBackgroundColor }}
          now={25}
          key={3}
        />
        <ProgressBar
          style={{ backgroundColor: pendingProgressBackgroundColor }}
          now={17}
          key={4}
        />
        <ProgressBar
          style={{ backgroundColor: pendingProgressBackgroundColor }}
          now={16}
          key={5}
        />
        <ProgressBar
          style={{ backgroundColor: pendingProgressBackgroundColor }}
          now={17}
          key={6}
        />
      </ProgressBar>
      <ProgressBar style={{ height: "2rem", fontSize: "0.9rem" }}>
        <ProgressBar
          className="text-dark"
          variant="white"
          now={17}
          label="Application Received"
          key={1}
        />
        <ProgressBar
          className="text-dark"
          style={{ fontWeight: "bold" }}
          variant="white"
          now={16}
          label="Under Assessment"
          key={2}
        />
        <ProgressBar
          className="text-dark"
          variant="white"
          now={17}
          label="Application Compliance"
          key={3}
        />
        <ProgressBar
          className="text-dark"
          variant="white"
          now={17}
          label="Proposed Determination"
          key={4}
        />
        <ProgressBar
          className="text-dark"
          variant="white"
          now={16}
          label="Consideration of Objections"
          key={5}
        />
        <ProgressBar
          className="text-dark"
          variant="white"
          now={17}
          label="Authorisation Issued"
          key={6}
        />
      </ProgressBar>
    </div>
  ) as JSX.Element;

  return <EpaCard title={"Tracker"} content={bodyElements} />;
};

const LicenceApplicationTrackerV2 = ({
  licence,
  licenceProfile,
}: ILicenceDetailsProps) => {
  return (
    <div>
      <div className="d-lg-none">
        <LicenceApplicationTrackerMobile
          licence={licence}
          licenceProfile={licenceProfile}
        />
      </div>
      <div className="d-none d-lg-block">
        <LicenceApplicationTrackerMobile
          licence={licence}
          licenceProfile={licenceProfile}
        />
      </div>
    </div>
  );
};

const LicenceApplicationTrackerMobile = ({
  licence,
  licenceProfile,
}: ILicenceDetailsProps) => {
  const submissionUrl = GetSubmissionUrl(licence.regno);
  const objectionsUrl = GetMakeAnObjectionUrl(licence.regno);
  const bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <h3>{licence.lastatus}</h3>
          {licence.openforsubmissions ===
            OpenForSubmissionOptions.OpenForSubmissions && (
            <Button href={submissionUrl} target="_blank">
              {"Make a Submission"}
            </Button>
          )}
          {licence.openforsubmissions ===
            OpenForSubmissionOptions.OpenForObjections && (
            <Button href={objectionsUrl} target="_blank">
              {"Make an Objection"}
            </Button>
          )}
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return <EpaCard title={"Status"} content={bodyElements} />;
};

const LicenceApplicationTracker = ({
  licence,
  licenceProfile,
}: ILicenceDetailsProps) => (
  <LicenceApplicationTrackerV2
    licence={licence}
    licenceProfile={licenceProfile}
  />
);

export default LicenceApplicationTracker;
